import React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import {
  ModuleCompareActionTypes,
  useModuleCompare,
} from 'root/apps/ModuleCompareUI/context/Context';
import {
  StyledDeleteIcon,
  StyledSpan,
  StyledTooltip,
} from 'root/apps/ModuleCompareUI/ModuleCompare.style';

type DeleteModuleButtonProps = {
  moduleId: string;
  deleteAcId: string;
  moduleName: string;
};

export const DeleteModuleButton: React.FC<DeleteModuleButtonProps> = ({
  moduleId,
  deleteAcId,
  moduleName,
}) => {
  const { dispatch } = useModuleCompare();
  const mutation = useMutation({
    mutationFn: () => {
      return axios.delete(`/staff/account/${deleteAcId}/module/${moduleId}`);
    },
    onSuccess: () => {
      dispatch({
        type: ModuleCompareActionTypes.DELETE_MODULE_FROM_ACCOUNT,
        payload: { accountId: deleteAcId, moduleId },
      });
    },
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error(`Error deleting module:${moduleId} from account:${deleteAcId}`, error);
    },
  });
  const handleDeleteClick = () => {
    // eslint-disable-next-line no-alert
    const confirmationAgreed = window.confirm(
      `Are you sure you want to DELETE module: ${
        moduleName ?? moduleId
      } from account:${deleteAcId}?`
    );

    if (confirmationAgreed) {
      mutation.mutate();
    }
  };

  if (mutation.isLoading) {
    return <Button fill variant="danger" size="small" loading />;
  }

  return (
    <StyledSpan
      role="button"
      style={{ height: '30px', width: '26px', paddingLeft: '4px', paddingTop: '4px' }}
      tabIndex={0}
      onClick={handleDeleteClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleDeleteClick();
        }
      }}
    >
      <StyledTooltip
        content={`Delete module: ${moduleName ?? moduleId} from account: ${deleteAcId}`}
      >
        <StyledDeleteIcon />
      </StyledTooltip>
    </StyledSpan>
  );
};
